<template>
    <section>
        <div class="cabinet-history">
            <cabinet-history-item
                v-for="item in items"
                :result="item"
                :key="item.id"
                :delivery="item.delivery"
                :items="item.items"
                :prices="item.price"
                :properties="item.properties"
                :paySystem="item.paySystem"
                :status="item.status"
                :statusColor="item.statusColor"
                :printStatus="item.printStatus"
                :date="item.dateInsertFormat"
                :id="item.id"
                :nameCount="item.nameCount"
                :summMessage="item.summMessage"
            />
        </div>
        <Pagination
            :result="pagination"
            @change="getPage"
            @addMore="addMore"
        />
    </section>
</template>

<script>
import { mapState } from 'vuex';
    export default {
        name: 'cabinet-history',
        selector: '.cabinet-history',
        data(){
            return{
                //items : {}
            }
        },
        computed: {
            ...mapState({
                items: ({personalCabinet}) => personalCabinet?.data?.items,
                pagination: ({personalCabinet}) => personalCabinet?.data?.pagination,
            })

        },
        methods: {


            /**
             * Имитация перехода на нужную страницу
             */
            replaceResponse(response) {
                // console.log(response.data.items);
                // console.log(this.items);
                //this.pagination = response.data.pagination;
                this.items = response.data.items;
            },
            /**
             * Метод по которому происходит Ajax переход на нужную страницу
             * @param numb
             */
            getPage(numb) {
                this.$store.dispatch('personalCabinet/getPage', {
                    obj: {[this.pagination.pagingKey]: numb, api: 'y'},
                    path: window.location.href,
                })
            },
            /**
             * Метод по которому происходит Ajax загрузка данных (добавление)
             */
            addMore () {

            },

        },
        mounted() {
            // console.log(this.pagination);
        }
    }
</script>

<style lang="scss" scoped>
    .cabinet-history {
    }
    .test-div{
      //display: grid;
      //grid-template-columns: 1fr;
      //grid-gap: 20px 20px;
      //@include point-md{
      //  grid-template-columns: repeat(2, 1fr);
      //}
      //@include point-lg{
      //  grid-template-columns: repeat(4, 1fr);
      //}
      //@include grid(1, 0, 30);
      //@include grid-md(2, 20, 20);
      //@include grid-lg(4, 30, 0);
    }
</style>